import '@oneclick/react-lemonade-editor/dist/index.css';
import '@oneclick/react-mint-editor/dist/style.css';
import '@oneclick/react-videolesson/dist/style.css';
import { initSentry } from 'app/config/configSentry';
import { setupAxios } from 'app/config/axios.config';
import axios from 'axios';
import React from 'react';
import 'react-day-picker/dist/style.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'regenerator-runtime/runtime';
import App from './App';
import * as env from './app/config/environment';
import { initializeLatex } from './app/config/initializeLatex';
import store, { persistor } from './app/store/store';
import './index.scss';

const { PUBLIC_URL, REACT_APP_WEBSITE_NAME, REACT_APP_VERSION, REACT_APP_VERSION_DATE, NODE_ENV } = process.env;
const { API_URL } = env[process.env.REACT_APP_ENV] || env.defaultConfig;

initSentry();
initializeLatex();
setupAxios(axios, API_URL, store);

const root = createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename={PUBLIC_URL}>
    <App store={store} persistor={persistor} />
  </BrowserRouter>
);

console.log(
  `%c${process.env.REACT_APP_WEBSITE_NAME} v${process.env.REACT_APP_VERSION} - ${process.env.REACT_APP_VERSION_DATE}`,
  'color: #007aff; font-weight: bold;'
);
